<template>
  <div id="app">
    <aside class="list">
      <h3 class="list__title">Lista de posts</h3>
      <div class="nav">
        <router-link class="nav__list" 
                     v-for="post in posts" 
                     :key="post.id" 
                     :to="{ name: 'post', params: { id: post.id }}">
          {{ post.id }}. {{ post.title }}
        </router-link>
      </div>
    </aside>
    <main class="main">
      <nav class="navbar">
        <router-link :to="{ name: 'home' }">Inicio</router-link>
        <router-link :to="{ name: 'contact' }">Contacto</router-link>
      </nav>
      <div class="main__content">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable */
// import HelloWorld from './components/HelloWorld.vue'
import axios from 'axios';

export default {
  name: 'app',

  data() {
    return {
      posts: null,
      endpoint: 'https://jsonplaceholder.typicode.com/posts/',
    }
  },

  created: function() {
    this.getPosts();
  },
  
  methods: {
    getPosts() {
      axios.get(this.endpoint)
          .then(response => this.posts = response.data)
          .catch(err => console.log(err));
    }
  },

  components: {
  }

}
</script>

<style lang="scss">
// Global variables
@import url('https://fonts.googleapis.com/css?family=Montserrat');

// Global styles
%dev {
  border: 1px solid tomato;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  // @extend %dev;
  margin: 0;
  padding: 0;
  height: 100vh;
  // background-color: #fafafa;
  background: linear-gradient(to bottom, #dad6f7, #db3186, #641010 );
  display: flex;
  justify-content: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.5em;
  color: #3b3b3b;
}
a {
  color: blue;
  text-decoration: none;
  
  &:link {
    color: blue;
  }
  &:hover {
    color: black;
  }
}
@for $i from 1 through 6 {
  h#{$i} {
    font-family: 'Montserrat', sans-serif;
    color: #5443b6;
    line-height: 3rem;
    font-weight: 300;
  }
}

// Custom styles
.router-link-active {
  color: rgb(253, 2, 211);
}

#app {
  // @extend %dev;
  background-color: white;
  border: 1px solid #dadada;
  border-radius: 5px;
  // box-shadow: 1px 5px 20px #dadada;
  width: 80%;
  margin: 30px 0px;
  display: flex;
}

.list {
  // @extend %dev;
  width: 30%;
  padding: 10px;
  overflow-y: auto;
  h3 {
    margin: 0;
  }
}

.nav {
  // @extend %dev;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;

  &__list {
    // @extend %dev;
    padding: 5px;
    margin-bottom: 10px;
    list-style: circle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-decoration: none;
  }
}

.main {
  // @extend %dev;
  width: 70%;
  padding: 10px;
  overflow-y: auto;
  background-color: #ffffff;
}
.navbar {
  // @extend %dev;
  padding: 10px;
  a {
    padding: 10px;
    background-color: #fafafa;
    border: 1px solid #fafafa;
    border-radius: 5px;
    box-shadow: 3px 3px 15px #cacaca;
    margin: 5px;
  }
}

@media screen and (max-width: 768px) {
  body {
    background: none;
    background-color: #3b3b3b;
  }
  #app {
    width: 100%;
    margin: 0;
    border: none;
    border-radius: 0;
    flex-direction: column;
  }
  .list {
    margin-top: 55px;
    width: 100%;
    max-height: 40%;
    .list__title {
      background-color: #fd7171;
      color: white;
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      padding: 5px;
    }
  }
  .main {
    width: 100%;
    height: 100%;
  }

}
</style>
